import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { retry, catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { BaseComponents } from '../base.component';

@Injectable()
export class BlogService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }
  getBlogHome(): Observable<any> {
    //let url = '/assets/data-blog/blog-home.json';
    let url = '/contents/images/blogs/blog-home.json';
    return this.httpClient.get(url).pipe(
      ///retry(1),
      catchError(this.handdleException),
      map(payload => {
        //this.logger.info("payload: ", payload)
        let result: any = payload
        return result
      }),
    )
  }

  getBlogContents() {
    let self = this;
    //let url =  '/assets/data-blog/blog-contents.json';
    let url = '/contents/images/blogs/blog-contents.json';
    return new Promise(function (resolve, reject) {
      self.httpClient.get(url).pipe(
        catchError(self.handdleException),
        map(payload => {
          let result: any = payload
          return result
        }),
      ).subscribe(res=>{
        resolve(res)
      })
    });
  }

  handdleException(error: HttpErrorResponse): Observable<never> {
    //this.logger.info(error)
    return throwError(error)
  }
}
